export { getWindow as getOwnerWindow } from "@floating-ui/utils/dom"

export function getOwnerDocument(node: Element | null) {
  return node?.ownerDocument || document
}
